import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IMetricUsageInfo } from '../../../spacesPlatform/models/IUsageInfo';
import { INamedItem, ITypedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IConnectedView, IMetric } from '../types/IMetric';

export interface IGetMetricsParams extends IGetItemsParams {
}

export interface IGetMetricsResult extends IGetItemsResult {
  metrics?: IMetric[];
  users?: IUser[];
  connectedViews: IConnectedView[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  favorites?: string[];
  maxStats?: IMetricUsageInfo;
}

export class GetMetricsRequest extends Request<IGetMetricsParams, IGetMetricsResult> {
  constructor(params: IGetMetricsParams) {
    super('getMetrics', params);
  }
}
